import React from "react";
import "./App.css";
import Header from "./components/header";
import Footer from "./components/footer";
import { Routes } from "./routes";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    
      <div className="container">
        
        <Header />
        <Routes />
        <Footer />
        <Toaster />
      
      </div>
    
  );
}

export default App;
